import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  getSingleItems,
  selectSingleItems,
  selectSingleItemsLoading,
  setSingleItems,
} from '@core-app/state/ui';
import { SharedModule } from '@frontend-workspace/shared/src';
import { TableColumn } from '@frontend-workspace/shared/src/lib/components/table/table.component';
import { SingleItem } from '@frontend-workspace/shared/src/lib/interfaces';
import { Store } from '@ngrx/store';

@Component({
  selector: 'frontend-workspace-parts-modal',
  imports: [SharedModule, CommonModule],
  templateUrl: './parts-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parts-modal.component.css',
})
export class PartsModalComponent implements OnInit {
  data = inject<{
    articleId: string;
    batchId: string;
  }>(MAT_DIALOG_DATA);

  private readonly _store = inject(Store);
  destroyRef = inject(DestroyRef);
  singleItems$ = this._store.select(selectSingleItems());
  singleItemsLoading$ = this._store.select(selectSingleItemsLoading());

  cols: TableColumn<SingleItem>[] = [
    {
      index: 'articleId',
      label: 'Article ID',
      key: 'articleId',
    },
    {
      index: 'externalSingleItemId',
      label: 'External Single Item ID',
      key: 'externalSingleItemId',
    },
    {
      index: 'singleItemId',
      label: 'Single Item ID',
      key: 'singleItemId',
    },
    {
      index: 'batchId',
      label: 'Batch',
      key: 'batchId',
    },
  ];

  colsDisplay = [
    'singleItemId',
    'articleId',
    'batchId',
    'externalSingleItemId',
  ];

  ngOnInit() {
    this._store.dispatch(setSingleItems({ singleItems: [] }));

    this._store.dispatch(
      getSingleItems({
        articleId: this.data.articleId ?? '',
        batchId: this.data.batchId ?? '',
      }),
    );
  }
}
